import React from 'react'

const Loading: React.FC = () => {
  return (
    <>
      <h1>Loading</h1>
    </>
  )
}

export default Loading
